class Param {
    paramName = "";
    paramType = 0;
    paramItems: ParamItem[];

    constructor() {
        this.paramItems = [];
    }
}

class ParamItem {
    itemName = "";
    // accuracyLevels: AccuracyLevel[];
    surveyRanges: SurveyRange[];

    constructor(surveyRanges: SurveyRange[]) {
        // this.accuracyLevels = accuracyLevels;
        this.surveyRanges = surveyRanges;
    }
}

class SurveyRange {
    connector = "";
    lowerLimit = "";
    lowerLimitPrefix = "";
    lowerLimitSuffix = "";
    prefix = "";
    suffix = "";
    symbol = "";
    upperLimit = "";
    upperLimitPrefix = "";
    upperLimitSuffix = "";
    upperUnit = "";
    upperUnitId = 0;
    lowerUnit = "";
    lowerUnitId = 0;
    accuracyLevel = "";

}

class AccuracyLevel {
    maxError: string;

    // type: number;
    constructor() {
        this.maxError = '';
        // this.type = 0;
    }
}

class SurveyRangeVo extends SurveyRange {
    connector = ""; //连接符号
    paramName = ""; //参数名称
    paramItemName = ""; //附加参数名称
    dataType = "param"; // param  paramItem surveyRange
    //param每一组的标识
    paramGroupIndex = 1;
    //paramItem每一组的标识
    paramItemGroupIndex = 1;
    // surveyRange = {} as SurveyRange; //测量范围
    accuracyLevels = [new AccuracyLevel()] as AccuracyLevel[]; //不确定度等级
}


//转换类
class Convert {

    public static paramListToSurveyRangeVo(paramList: Param[]) {
        let surveyRangeList = [] as SurveyRangeVo[];
        if (paramList == undefined || paramList == null || paramList.length === 0) {
            surveyRangeList = [new SurveyRangeVo()];
            return surveyRangeList;
        }
        let paramGroupIndex = 0;
        paramList.forEach((param, pIndex) => {
            paramGroupIndex++;
            const {paramName, paramItems} = param;
            let paramItemGroupIndex = 0;
            if(!paramItems) return;
            paramItems.forEach((item, iIndex) => {
                const {itemName, surveyRanges} = item;
                paramItemGroupIndex++;
                surveyRanges.forEach((sr, sIndex) => {
                    const surveyRangeVo = new SurveyRangeVo();
                    Object.assign(surveyRangeVo, sr);
                    surveyRangeVo.paramName = paramName;
                    surveyRangeVo.paramItemName = itemName;
                    surveyRangeVo.paramGroupIndex = paramGroupIndex;
                    surveyRangeVo.paramItemGroupIndex = paramItemGroupIndex;
                    surveyRangeVo.dataType = (iIndex === 0 && sIndex === 0) ? "param" : (sIndex === 0 ? "paramItem" : "surveyRange");
                    surveyRangeVo.accuracyLevels = sr.accuracyLevel ? JSON.parse(sr.accuracyLevel) : [];
                    surveyRangeVo.prefix = paramName;
                    surveyRangeList.push(surveyRangeVo);
                });
            });
        });
        return surveyRangeList;
    }

    public static surveyRangeVoToParamList(srList: SurveyRangeVo[]) {
        const paramList = [] as Param[];
        //1.先搂出最顶级的param
        const paramSrList = srList.filter((sr) => sr.dataType === 'param');
        paramSrList.forEach((psr) => {
            const {paramGroupIndex, paramItemGroupIndex, paramItemName} = psr;
            const param = new Param();
            param.paramName = psr.paramName;
            {
                //2.再搂出paramItem param自带一个paramItem
                const paramItemSrList = srList.filter((sr) => sr.paramGroupIndex === paramGroupIndex && ( sr.dataType === 'param' || sr.dataType === 'paramItem'));
                paramItemSrList.forEach((paramItemSr) => {
                    const {paramItemGroupIndex} = paramItemSr;
                    //3.再搂出测量范围
                    const paramItemSrList = srList.filter((sr) => sr.paramGroupIndex === paramGroupIndex && sr.paramItemGroupIndex === paramItemGroupIndex);
                    paramItemSrList.forEach((sr) => {
                        sr.prefix = param.paramName;
                        sr.accuracyLevel = JSON.stringify(sr.accuracyLevels);
                    });
                    const paramItem = new ParamItem(paramItemSrList);
                    paramItem.itemName = paramItemSr.paramItemName;
                    param.paramItems.push(paramItem);
                });
            }
            paramList.push(param);
        });
        return paramList;
    }
}

export {Param, ParamItem, AccuracyLevel, SurveyRange, SurveyRangeVo, Convert} ;
